import React from "react";
import cn from "classnames";
import { CUSTOM_MESSAGES } from "../../veriables";
import { ReactComponent as GiftCardWarning } from "@assets/images/warning.svg";

const ServerInstructions = ({ orderingPortraitOrientation }) => {
  return (
    <div className={cn("col-12  px-3" , orderingPortraitOrientation ? 'pb-24' :'pb-2' )}>
      <div
        className={cn("col-12 d-flex fw-400 fs_14 py-2 rounded")}
        style={{
          backgroundColor: "#FFD9AD",
        }}
      >
        <div className={cn("d-flex align-items-center mr-3")}>
          <GiftCardWarning />
        </div>
        <div className="fs_12 fw-400">
          {CUSTOM_MESSAGES().SERVER_INSTRUCTION_FOR_GIFT_CARD}
        </div>
      </div>
    </div>
  );
};

export default ServerInstructions;